// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {
  PriceoverviewState,
  ProductWithPosition,
} from 'redux/uiState/priceoverview/PriceoverviewState';
import type {Price} from 'v1/journey/models';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  INVIA_TYPE_CAN_FREE,
  INVIA_TYPE_CAN_INCLUDED,
  INVIA_TYPE_RES_INCLUDED,
} from 'consts';
import {
  ADD_PRICEOVERVIEW_PRODUCT,
  REMOVE_PRICEOVERVIEW_PRODUCT,
} from 'redux/uiState/priceoverview/actions';
import {PRICEOVERVIEW_POSITION_JOURNEY} from 'redux/uiState/priceoverview/models';
import {priceoverviewState} from 'redux/uiState/UiState';


const initialState: PriceoverviewState = {
  products: [],
};

const actionCreators: ActionHandlers<PriceoverviewState> = {
  [PURE(ADD_PRICEOVERVIEW_PRODUCT)]: (
    state: PriceoverviewState,
    action: {product: ProductWithPosition}
  ) => ({
    ...state,
    products: [
      ...state.products.filter(
        (p: ProductWithPosition) => p.position !== action.product.position
      ),
      action.product,
    ],
  }),
  [PURE(REMOVE_PRICEOVERVIEW_PRODUCT)]: (
    state: PriceoverviewState,
    action: {position: number}
  ) => {
    return {
      ...state,
      products: state.products.filter(
        (p: ProductWithPosition) => p.position !== action.position
      ),
    };
  },
};

export const priceoverviewReducer: Reducer<PriceoverviewState> = // $FlowIgnore
  createReducerUsingActionHandlers<PriceoverviewState>(
    initialState,
    actionCreators
  );

export const getTotalPrice: Selector<Price> = createSelector(
  priceoverviewState,
  (state: PriceoverviewState) =>
    state.products
      .filter(
        (p: ProductWithPosition) =>
          p.type !== INVIA_TYPE_CAN_INCLUDED &&
          p.type !== INVIA_TYPE_CAN_FREE &&
          p.type !== INVIA_TYPE_RES_INCLUDED
      )
      .reduce(
        (accumulator, a) => ({
          price: {
            amount: accumulator.price.amount + a.price.value,
            currency: a.price.currency,
          },
          displayPrice: {
            amount: accumulator.displayPrice.amount + a.displayPrice.value,
            currency: a.displayPrice.currency,
          },
        }),
        {
          price: {amount: 0, currency: ''},
          displayPrice: {amount: 0, currency: ''},
        }
      )
);

export const getProducts: Selector<ProductWithPosition[]> = createSelector(
  priceoverviewState,
  (state: PriceoverviewState) =>
    state.products.sort((a, b) => a.position - b.position)
);

export const getProductFromPosition: Selector<ProductWithPosition> =
  createSelector(
    [priceoverviewState, (_, position: number) => position],
    (state: PriceoverviewState, position: number) =>
      state.products.find((p: ProductWithPosition) => p.position === position)
  );

export const getAdditionals: Selector<ProductWithPosition[]> = createSelector(
  priceoverviewState,
  (state: PriceoverviewState) =>
    state.products
      .filter(
        (p: ProductWithPosition) =>
          p.position !== PRICEOVERVIEW_POSITION_JOURNEY
      )
      .sort((a, b) => a.position - b.position)
);
